<template>
  <div class="background-small">
    <div class="f sb flex-start pb-4 px-3">
      <h4 class="text-white">CS2 Collections</h4>
    </div>
    <div class="wrapper px-3">
      <div v-if="itemLoading" class="collection_grid">
        <ShimmerEffect v-for="index in filterObject.pageSize" :key="index" />
      </div>
      <div>
        <div v-if="!itemLoading" class="collection_grid py-2">
          <CollectionCard
            @go-item="goCollection"
            v-for="item in collections"
            :key="item.name"
            :item="item"
          />
        </div>
      </div>
    </div>
    <div class="page_row pt-2 pb-3 f align-center">
      <PaginationRow
        :pageNumber="filterObject.pageNumber"
        :totalPages="totalPages"
        @update:pageNumber="filterObject.pageNumber = $event"
      />
    </div>
  </div>
</template>
<script>

import CollectionCard from "@/components/collection/CollectionCard.vue";
import ItemService from "@/services/ItemService.js";
import ShimmerEffect from "@/components/skeleton/ShimmerCard.vue";
import DateUtils from "@/utils/DateUtils.js";
import steamIcon from "@/assets/images/steam-white.png";

export default {
  data() {
    return {
      title: "Collection",
      stats: {
        total: 0,
      },
      totalPages: 10,
      caseInfo: {},
      items: [],
      rareItems: [],
      collections: [],
      loading: true,
      itemLoading: true,
      isDropdownOpen: false,
      steamIcon: steamIcon,
      filterObject: {
        pageSize: 20,
        pageNumber: 1,
        orderDir: "DESC",
        orderBy: "date",
        market: "all",
      },
      orderOptions: ["Price", "Name", "Rarity"],
      selectedOrder: "Price",
      selectedDirection: "DESC",
      caseName: "",
      caseID: null,
      tempArray: [],
      isRareView: false,
    };
  },
  methods: {
    async setOrderDir(isAscOrder) {
      this.filterObject.orderDir = this.selectedDirection = isAscOrder
        ? "ASC"
        : "DESC";
      this.sortItems();
    },
    async setOrderBy(option) {
      this.filterObject.orderBy = option.toLowerCase();
      this.selectedOrder = option;
    },
    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen;
    },
    async getCollections() {
      this.itemLoading = true;
      const response = await ItemService.getAllCollections({
        currentPage: this.filterObject.pageNumber,
        pageSize: this.filterObject.pageSize,
      });

      if (!response) return;
      this.collections = response;
      this.itemLoading = false;
    },
    checkIfMobile() {
      this.isMobile = window.innerWidth < 1000;
    },
    async goCollection(id, collection) {
      this.$router.push({
        name: "collection",
        params: { name: collection },
        query: { id: id },
      });
    },
  },
  async created() {
    await this.getCollections();
  },
  mounted() {
    this.checkIfMobile();
    window.addEventListener("resize", this.checkIfMobile);
  },
  computed: {
    DateUtils() {
      return DateUtils;
    },
  },
  watch: {
    filterObject: {
      handler() {
        this.getCollections();
      },
      deep: true,
    },
  },
  components: {
    CollectionCard,
    ShimmerEffect,
  },
};
</script>
<style scoped>
@import "@/assets/style/customTable.css";

p {
  margin-bottom: 0;
}

.collection_grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  grid-gap: 20px;
  align-items: stretch;
}

.open_case {
  background-image: linear-gradient(
    to right,
    #25aae1,
    #40e495,
    #30dd8a,
    rgb(38, 133, 92)
  );
  box-shadow: 0 4px 15px 0 rgba(49, 196, 190, 0.75);
  padding: 4px 8px;
  width: 140px;
  font-size: 14px;
  font-weight: bold;
  color: white;
  cursor: pointer;
  margin-top: 5px;
  height: 40px;
  text-align: center;
  border: none;
  background-size: 300% 100%;
  border-radius: 4px;
  moz-transition: all 0.4s ease-in-out;
  -o-transition: all 0.4s ease-in-out;
  -webkit-transition: all 0.4s ease-in-out;
  transition: all 0.4s ease-in-out;
}

.open_case:hover {
  transition: 0.3s;
  background-position: 100% 0;
  moz-transition: all 0.4s ease-in-out;
  -o-transition: all 0.4s ease-in-out;
  -webkit-transition: all 0.4s ease-in-out;
  transition: all 0.4s ease-in-out;
}

@media screen and (max-width: 728px) {
  .filter-div-mobile {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .mid-span {
    font-size: 16px;
  }

  p {
    font-size: 16px;
  }
}

h4 {
  margin-bottom: 0;
}
</style>
